import Vue from 'vue';
const cashierEnums = [
  {
    value: 0,
    min: 0,
    max: 0,
  },
  {
    value: 1,
    min: 0.1,
    max: 500,
  },
  {
    value: 2,
    min: 500.1,
    max: 1327.87,
  },
  {
    value: 3,
    min: 1323.88,
    max: 1800,
  },
  {
    value: 4,
    min: 1800.1,
    max: null,
  },
];

function getDepositValue(value) {
  let currentValue = cashierEnums.find(item => {
    if (item.max !== null) {
      return value >= item.min && value <= item.max;
    }
    return value >= item.min;
  });

  return currentValue ? currentValue.value : 0;
}

const gaHelper = {
  getDepositValue,
};

Vue.prototype.$gaHelper = gaHelper;
